import axios from 'axios'

export default {
  getStatsForYearAndMonth (year, month) {
    return axios
      .get('/duties/stats/' + year + '/' + month)
      .then(resp => {
        return resp.data
      })
  }
}



// WEBPACK FOOTER //
// ./src/service/statsService.js